export const CHANGE_CURRENT_PAGE = 'shipstationSettings/CHANGE_CURRENT_PAGE'
export const CHANGE_PAGE_SIZE = 'shipstationSettings/CHANGE_PAGE_SIZE'
export const CREATE_SHIPSTATION_SETTING = 'shipstationSettings/CREATE_SHIPSTATION_SETTING'
export const FETCH_SHIPSTATION_SETTINGS_LIST = 'shipstationSettings/FETCH_SHIPSTATION_SETTINGS_LIST'
export const FETCH_SHIPSTATION_SETTINGS_FOR_OPTIONS = 'shipstationSettings/FETCH_SHIPSTATION_SETTINGS_FOR_OPTIONS'
export const REMOVE_SHIPSTATION_SETTING = 'shipstationSettings/REMOVE_SHIPSTATION_SETTING'
export const UPDATE_SHIPSTATION_SETTING = 'shipstationSettings/UPDATE_SHIPSTATION_SETTING'
